import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Audience } from 'src/app/models/services/audience';
import { AudiencesService } from 'src/app/services/audiences/audiences.service';
import { DialogService } from 'src/app/services/core/dialog.service';
import { AudienceParametersDialogService } from 'src/app/services/dialogs/audience-parameters-dialog.service';
import { GlobalsService } from 'src/app/services/globals.service';
import { UsersService } from 'src/app/services/users.service';
import { ThemeOptions } from 'src/app/theme-options';

@Component({
  selector: 'app-audience-transfers',
  templateUrl: './audience-transfers.component.html',
  styleUrls: ['./audience-transfers.component.sass']
})
export class AudienceTransfersComponent implements OnInit {  
  public heading: string = '';
  public subheading: string = '';
  public icon: string = 'pe-7s-albums icon-gradient bg-midnight-bloom';

  audienceId: number;
  audience: Audience;
  navigationUrlBase: string;
  selectedTabIndex: number = 0;
  loading = true;

  constructor(
    private globals: ThemeOptions,
    private route: ActivatedRoute,
    private audiencesServices: AudiencesService,
    private dialogService: DialogService,
    private spinnerService: NgxSpinnerService,
    private globalsService: GlobalsService,
    private usersService: UsersService,
    private router: Router) { }

  ngOnInit(): void {
    // If no active company navigate to root
    if (!this.globalsService.getActiveCompany() || !this.usersService.hasSelectedCompanyActionRight('Audiences', 'AudiencesList', 'Manage')) {
      this.router.navigate(["/"]);
      return;
    }

    this.spinnerService.show();
    this.globals.backEnabled = true;
    this.audienceId = +this.route.snapshot.paramMap.get('audienceId');
    this.globals.backLabel = "Back to audiences list";
    this.navigationUrlBase = "/audiences";
    /*
    this.route.data.subscribe(data => {
      this.sourceType = data.sourceType;
      // If no rights navigate to root
      var audienceId = +this.sourceIdentifier;
      this.audiencesServices.getAudience(audienceId).subscribe(
        (data: Audience) => {
          this.heading = `Audience '${data.name}' look alikes`;      
        }      
      );            
      
      
    });
    */
    this.audiencesServices.getAudience(this.audienceId).subscribe(
      (data: Audience) => {
        this.spinnerService.hide();
        this.audience = data;
        this.heading = `Audience '${this.audience.id} - ${this.audience.name}' transfers`;    
        this.loading = false;
      },
      () => {
        this.spinnerService.hide();
        this.dialogService.showError("Error loading audience transfers");
        this.loading = false;
      }      
    );    
  }

  ngOnDestroy(): void {
    this.globals.backEnabled = false;
    this.globals.backLabel = "";
  }

  getStatusStyle = (index: number): string => {
        return "pe-7s-check";
  }

  getStatusLabel = (index: number): string => {
        return "Done";
  }

  /*
  createAudience = (index: number): void => {
    let lookAlike: LookAlike = this.lookAlikes[index];
    this.audienceParametersDialogService.show(
      (audienceParameters: AudienceParameters) => {
        // Save audience
        this.spinnerService.show();
        let request: CreateAudienceRequest = {
          name: audienceParameters.name,
          categoryId: audienceParameters.categoryId,
          query: lookAlike.conditions,
          lookAlikeSourceType: this.sourceType,
          lookAlikeSourceIdentifier: this.sourceIdentifier,
          schedulingId: audienceParameters.schedulingId,
          schedulingEndDate: audienceParameters.schedulingEndDate
        };
        this.audiencesServices.createAudience(request).subscribe(
          () => {
            this.spinnerService.hide();
            this.dialogService.showMessage("Create audience", "Audience created");
          },
          () => {
            this.spinnerService.hide();
          }
        );
      },
      () => { }
    );  
  }

  deleteLookAlike = (index: number): void => {
    let data: LookAlike = this.lookAlikes[index];
    this.dialogService.showConfirmation(
      `Are you sure to remove "${data.name}"?`,
      () => {        
        this.lookAlikesServices.removeLookAlike(this.sourceType, data).subscribe(
          () => {
            this.lookAlikes.splice(index, 1);
          });        
      },
      () => { });
  }  
  */

}
